import React, { useState } from "react";

import ModifSct from "./TypeMission/ModifSct";
import CreationSct from "./TypeMission/CreationSct";
import DroitSocieaux from "./TypeMission/DroitSociaux";
import Radiation from "./TypeMission/Radiation";
import Autre from "./TypeMission/Autre";

import { Briefcase } from "lucide-react";

// Depuis un mail (Mails.jsx, bouton "En mission ponctuelle") : { clientId,
// nomClient, commentaire } — pré-rempli sur les 4 onglets qui ont un champ
// client (ModifSct, DroitSocieaux, Radiation, Autre), quel que soit celui
// affiché en premier ou ceux visités ensuite. "Immatriculation" (CreationSct)
// n'a volontairement pas de champ client (formLeadId, pas clientId — sert à
// créer une société pour un prospect, pas pour un client existant), donc ne
// reçoit pas ce prefill.
function Mission({ onCancel, prefill }) {
  // Par défaut "CreationSct" (Immatriculation) comme avant — mais depuis un
  // mail, ce serait le seul onglet SANS le prefill visible à l'ouverture ;
  // "Autre" (catch-all) s'ouvre en premier à la place dans ce cas.
  const [selectedDiv, setSelectedDiv] = useState(() => (prefill ? "Autre" : "CreationSct"));

  const navItems = [
    { name: "CreationSct", label: "Immatriculation" },
    { name: "ModifSct", label: "Modification de Société" },
    { name: "DroitSocieaux", label: "Cession de droit sociaux" },
    { name: "Radiation", label: "Radiation" },
    { name: "Autre", label: "Autre" },
  ];

  const renderSelectedComponent = () => {
    switch (selectedDiv) {
      case "ModifSct":
        return <ModifSct onCancel={onCancel} prefill={prefill} />;
      case "CreationSct":
        return <CreationSct onCancel={onCancel} />;
      case "DroitSocieaux":
        return <DroitSocieaux onCancel={onCancel} prefill={prefill} />;
      case "Radiation":
        return <Radiation onCancel={onCancel} prefill={prefill} />;
      case "Autre":
        return <Autre onCancel={onCancel} prefill={prefill} />;
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{ width: "100%" }}
        className="px-8 pt-6 pb-4 border-b bg-gradient-to-r from-[#9B1B5D]/5 to-transparent mb-5"
      >
        <div className="text-2xl font-bold text-slate-900 flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#9B1B5D] flex items-center justify-center">
            <Briefcase className="w-5 h-5 text-white" />
          </div>
          Mission Ponctuelle
        </div>
      </div>

      <div
        className="grid grid-cols-5 w-full mx-8 mt-1 bg-slate-100 p-1.5 rounded-xl"
        style={{ width: "85%" }}
      >
        {navItems.map((item) => {
          const isActive = selectedDiv === item.name;

          return (
            <div
              key={item.name}
              onClick={() => setSelectedDiv(item.name)}
              className={`
          cursor-pointer
          rounded-lg
          text-xs
          text-center
          px-3
          py-2
          transition-all
          ${
            isActive
              ? "bg-[#9B1B5D] text-white shadow-md"
              : "text-slate-700 hover:bg-slate-200"
          }
        `}
            >
              {item.label}
            </div>
          );
        })}
      </div>

      <div style={{ width: "90%" }}>
        <div className="selectedDiv">{renderSelectedComponent()}</div>
      </div>
    </div>
  );
}

export default Mission;
